import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';

import "assets/vendors/style";

import {Provider} from 'react-redux';
import {store} from './redux/store';

import App from './App';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement

);

/*window.onload = ()=>  {
        document.onkeydown = function (e) {

            return !(e.code == "F12" || e.code == "F5" || e.code == "F10" || e.code == "F7");
        };
}*/

root.render(
    <Provider store={store}>
        <App />
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
